import { Button, CircularProgress, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

import i18n from '_utils/i18n';

/* */
const styles = (theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  textField: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  submit: {
    marginTop: theme.spacing.unit * 2,
  },
});

/* */
class LoginForm extends React.Component {
  /* */
  render() {
    const { errors, values, classes, handleBlur, handleChange, handleSubmit, isSubmitting } = this.props;

    return (
      <form className='form'>
        <TextField
          required
          fullWidth
          name='email'
          type='email'
          label={i18n.t('auth.form.labels.email')}
          variant='outlined'
          onBlur={handleBlur}
          value={values.email}
          onChange={handleChange}
          error={!!errors.email}
          className={classes.textField}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          required
          fullWidth
          name='password'
          type='password'
          variant='outlined'
          label={i18n.t('auth.form.labels.password')}
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.password}
          error={!!errors.password}
          className={classes.textField}
          InputLabelProps={{
            shrink: true,
          }}
          onKeyUp={(e) => e.keyCode === 13 && handleSubmit.call()}
        />
        <Button
          fullWidth
          size='large'
          color='secondary'
          className={classes.submit}
          onClick={handleSubmit}
          variant='contained'
        >
          {isSubmitting ? <CircularProgress color='inherit' size={24} /> : i18n.t('auth.form.actions.log_in')}
        </Button>
      </form>
    );
  }
}

export default withStyles(styles)(LoginForm);
